import { render, staticRenderFns } from "./StepLotteryQualification.vue?vue&type=template&id=21b63faf&scoped=true"
import script from "./StepLotteryQualification.vue?vue&type=script&lang=ts"
export * from "./StepLotteryQualification.vue?vue&type=script&lang=ts"
import style0 from "./StepLotteryQualification.vue?vue&type=style&index=0&id=21b63faf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b63faf",
  null
  
)

export default component.exports